import React, { FC, ReactNode } from 'react';
import { mc, StyleProps } from '@styles';
import AngleIcon from './assets/angleIcon.svg';
import { TestIdProps } from '@utils';

interface Props extends StyleProps, TestIdProps {
  children?: ReactNode;
}

export const PostNutgraph: FC<Props> = ({ testId, style, className, children }) => (
  <section
    data-testid={testId}
    style={style}
    className={mc(
      'px-8 py-8',
      'relative',
      'border border-seafoam rounded-lg box-border',
      'text-xl font-raleway leading-normal font-semibold text-ocean-blue tracking-wide',
      className,
    )}
  >
    <span
      className="block absolute bg-no-repeat bg-contain pointer-events-none z-0"
      style={{ width: 50, height: 50, left: -3, top: -3, backgroundImage: `url(${AngleIcon})` }}
    />
    <span
      className="block absolute bg-no-repeat bg-contain pointer-events-none z-0"
      style={{ width: 50, height: 50, bottom: -3, right: -3, backgroundImage: `url(${AngleIcon})`, transform: 'rotate(180deg)' }}
    />
    {children}
  </section>
);

export type PostNutgraphProps = Props;
export default PostNutgraph;
